import { useEffect, useState, useRef } from 'react'
import { Section } from '../Layout/Elements'
import {
    VideoContainer,
    VideoEl
} from './Elements'

const Video = ({ data }) => {

    const video = useRef()
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        console.log(video.current)
        const obj = document.getElementById('video')

        console.log(obj)
    }, [])

    return (
        <Section minHeight="0">
            <VideoContainer>
                <VideoEl
                    autoPlay={true} 
                    loop={true}
                    controls={false} 
                    playsInline
                    muted 
                    src={data.src}
                    type="video/mp4"
                    /> 
            </VideoContainer>
        </Section>
    )
}

export default Video